import { Map } from 'immutable'
import { Component, OnInit } from '@angular/core'
import { getBusinessSubcategoriesState } from '@containers/business-categories/business-categories.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  DeleteBusinessSubcategoryRequest,
  SetDefaultData,
} from '@containers/business-categories/business-categories.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Subscription } from 'rxjs'

@Component({
  selector: 'business-subcategories',
  templateUrl: './business-subcategories.component.html',
  styleUrls: ['./business-subcategories.component.css'],
})
export class BusinessSubcategoriesComponent
  extends ListTrait
  implements OnInit
{
  public categoryId: number
  private state$: Subscription
  public isLoading: boolean = false
  public totalItems = 0
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
    },
    {
      name: 'SUBCATEGORY_TYPE',
      prop: 'subCategoryType',
      render: (column: Map<string, any>) => {
        return column.getIn(['defaultName'])
      },
    },
    {
      name: 'PROPERTY_TYPE',
      prop: 'propertyType',
    },
    {
      name: 'TEMPLATE',
      prop: 'template',
      render: (column: Map<string, any>) => {
        return column && column.getIn(['name'])
      },
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.categoryId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getBusinessSubcategoriesState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.totalItems = state.get('data').size
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  deleteBusinessSubcategory(id: number) {
    this.store.dispatch(
      new DeleteBusinessSubcategoryRequest(this.categoryId, id),
    )
  }
}
